<div class="m-quiz-finished">
  <h3>
    This quiz was finished!
  </h3>
</div>